require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-g-kwjb.json") })
        }
      }, "path---photos-professional-g-kwjb");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-g-kwjb!./.cache/json/photos-professional-g-kwjb.json
// module id = 753
// module chunks = 231608221292675